import { formatDistanceStrict, parseISO } from 'date-fns';
import dateFnsLocales from '../helpers/date-fns-locales';

const getTimeElapsedString = (dateCreated: string, locale: string): string => {
  const now = new Date();
  const dateCreatedFormatted = dateCreated ? parseISO(dateCreated) : '';
  if (dateCreatedFormatted && dateCreatedFormatted?.getDate()) {
    return formatDistanceStrict(dateCreatedFormatted, now, {
      addSuffix: true,
      locale: dateFnsLocales(locale)
    });
  }
  return '';
};

export default getTimeElapsedString;
